import { TOKEN_SYMBOL_ICON_PATH, SOL_SYMBOL_ICON_PATH } from '@/consts/imgPath';
import { IResponseBalance, IResponseUser } from '@/core/domain/entities/user';
import * as ViewModel from '@/core/presenter/viewModel';
import { getStores } from '@/stores';
import { formatNumber } from '@/utils';
import dayjs from 'dayjs';

/**
 * 유저 viewModel 변환 함수
 *
 * @export
 * @param {IResponseUser} resData
 * @return {*}  {ViewModel.IUser}
 */
export function toUser(resData: IResponseUser): ViewModel.IUser {
  // balance가 없을 경우를 대비한 기본값 설정
  const balance = resData.balance || {
    address: '',
    coinBalance: 0,
    coinKRW: 0,
    tokenBalance: 0,
    tokenKRW: 0,
    tokenBuyCount: 0,
    tokenBuyCountKRW: 0,
  };

  const ret: ViewModel.IUser = {
    shopCode: resData.shopCode,
    id: resData.id,
    phone: resData.phone,
    name: resData.name,
    status: resData.status,
    status_desc: resData.status_desc,
    address: balance.address,
    totalBalance: formatNumber(balance.coinKRW + balance.tokenKRW),
    balance: balance.coinBalance,
    krw: formatNumber(balance.coinKRW),
    tokenBalance: balance.tokenBalance,
    tokenKrw: formatNumber(balance.tokenKRW),
    solAsset: {
      name: '솔라나',
      symbol: 'SOL',
      balance: balance.coinBalance,
      krw: formatNumber(balance.coinKRW),
      iconPath: SOL_SYMBOL_ICON_PATH,
    },
    tokenAsset: {
      name: '골든파이넨스',
      symbol: 'GDF',
      balance: balance.tokenBalance,
      krw: formatNumber(balance.tokenKRW),
      iconPath: TOKEN_SYMBOL_ICON_PATH,
    },
    lastLoginTime: resData.lastLoginTime ? dayjs(resData.lastLoginTime).format('YYYY.MM.DD HH:mm') : '',
    isLocked: resData.isLocked,
  };

  return ret;
}

/**
 * 유저 자산 viewModel 변환 함수
 *
 * @export
 * @param {IResponseBalance} resData
 * @return {*}  {ViewModel.IMyAsset}
 */
export function toMyAsset(resData: IResponseBalance): ViewModel.IMyAsset {
  const { presentationStore } = getStores();

  const ret: ViewModel.IMyAsset = {
    coinAsset: {
      name: '솔라나',
      symbol: 'SOL',
      balance: resData.coinBalance,
      krw: formatNumber(resData.coinKRW),
      iconPath: SOL_SYMBOL_ICON_PATH,
      coinPrice: presentationStore.balance?.coinPrice,
    },
    tokenAsset: {
      name: '골든파이넨스',
      symbol: 'GDF',
      balance: resData.tokenBalance,
      krw: formatNumber(resData.tokenKRW),
      iconPath: TOKEN_SYMBOL_ICON_PATH,
      tokenPrice: presentationStore.balance?.tokenPrice,
    },
  };

  return ret;
}
